// Export hook
export { useLandingPage, useUnsavedChanges } from './useLandingPage';
export { useProfile, useSaveHighlights, useUpdateLandingFlag } from './useProfile';
export { 
  useApplicationsData, 
  calculateApplicationStats, 
  calculateAverageMatchScore,
  calculateClientSideMatchScore,
  hasApplicationData,
  getRecentApplications,
  getApplicationsByStatus
} from './useApplications';
export { useApplicationAccess } from './useApplicationAccess';
export { useQuota } from './useQuota';